import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-grey",
  "use": "icon-arrow-right-grey-usage",
  "viewBox": "0 0 16 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 32\" id=\"icon-arrow-right-grey\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.273 8.774 4.687 7.36l8.176 8.175c.26.26.26.683 0 .943l-8.176 8.176-1.414-1.414 7.233-7.233-7.233-7.233Z\" fill=\"#000\" opacity=\".3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol